module["exports"] = ["Slovensko"];